import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Box, CircularProgress } from "@mui/material";
import User from "../../stores/UserStore";
import General from "../../stores/GeneralStore";
import { useNavigate } from "react-router-dom";
import { Container } from "../login.screen/login.styled";
import { Spinner } from "../../components/SpinnerRaw/SpinnerRaw";
import { observer } from "mobx-react";

const DEFAULT_SENTINEL_VALUE = "";

const renderButtonContent = (isSubmitting: any) => {
  return isSubmitting ? (
    <Spinner width="30px" height="30px" style={{ color: "white" }} />
  ) : (
    General?.codeLabels["cm_submit"]?.label
  );
};
const validationSchema = Yup.object().shape({
  username: Yup.string().required(General?.codeLabels["cm_mob_passrqrd"]?.label),
});

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");

  const initialValues = {
    username: DEFAULT_SENTINEL_VALUE,
  };

  const handleSubmit = async (values: any) => {
    try {
    const res=  await User.forgotPassword({
        errorId: "forgotPasswordError",
        data: values.username,
      });
      if(res?.message == "Success"){
        navigate('/')
      }
    } catch (error) {
      setMessage("An error occurred while processing your request.");
    }
  };

  return (
    <Container style={{minHeight:'70vh'}}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "80%",
        }}
        className="forgotpassword-container"
      >
        <Box
          sx={{
            width:General?.isLargeScreen? "600px":"100%",
            padding: "50px",
            backgroundColor:General.contrast.contrastColor === 'yellow' ? '#0000FF' : (General.contrast.contrastColor === 'lime' ? '#000' : '#fff'),
            color: General.contrast.contrastColor? General.contrast.contrastColor === 'yellow' ? '#FFFF00' : (General.contrast.contrastColor === 'lime' ? '#00FF00' : ''):General?.ColorAss?'#fff':General?.ColorAss,
          }}
        >
          <h2
            style={{
              alignSelf: "center",
              fontWeight: "500",
              fontSize:General?.isLargeScreen? `${2.5 * General.accessibility.fontSize}rem`:`${1.5* General.accessibility.fontSize}rem`,
              color: General.contrast.contrastColor?General?.contrast.contrastColor === 'yellow' ? '#FFFF00' : (General.contrast.contrastColor === 'lime' ? '#00FF00' : '#101e8e'):General?.ColorAss?General?.ColorAss:''
            }}
          >
            {General?.codeLabels["cm_forgot_username"]?.label?General?.codeLabels["cm_forgot_username"]?.label:"Forgot Password"}
          </h2>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, isValid, dirty, values }) => (
              <Form>
                <label
                  htmlFor="username"
                  style={{
                    fontSize: `${0.8 * General.accessibility.fontSize}rem`,
                    color: General?.contrast.contrastColor?General?.contrast.contrastColor === 'yellow' ? '#FFFF00' : (General.contrast.contrastColor === 'lime' ? '#00FF00' : '#101e8e'):General?.ColorAss?General?.ColorAss:'',
                  }}
                >
                  {General?.codeLabels["cm_username"]?.label?General?.codeLabels["cm_username"]?.label:"User Name"}
                </label>
                <Field
                  fullWidth
                  required
                  name="username"
                  type="text"
                  margin="normal"
                  placeholder= {General?.codeLabels["cm_forcm_enterusernamegot_username"]?.label}
                  InputLabelProps={{ shrink: true }}
                  style={{
                    width: "100%",
                    height: "40px",
                    padding: "8px",
                    border: "1px solid rgba(182, 191, 220, 1)",
                    backgroundColor: "",
                    color:General?.contrast.contrastColor?General?.contrast.contrastColor === 'yellow' ? '#FFFF00' : (General.contrast.contrastColor === 'lime' ? '#00FF00' : '#101e8e'):General?.ColorAss?General?.ColorAss:'',
                  }}
                />
                <ErrorMessage
                  name="username"
                  component="div"
                  className="error-message"
                />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    marginTop: "40px",
                    gap: "10px",
                  }}
                >
                  <button
                    style={{
                      height: "3rem",
                      width: "100px",
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                      fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                      alignItems: "center",
                      backgroundColor:General.contrast.contrastColor? General?.contrast.contrastColor === 'yellow' ? '#FFFF00' : (General.contrast.contrastColor === 'lime' ? '#00FF00' : '#101e8e'):General?.ColorAss?General?.ColorAss:'',
                      cursor: "pointer",
                      color: General.contrast.contrastColor === 'yellow' ? '#0000FF' : (General.contrast.contrastColor === 'lime' ? '#000' : '#fff'),
                      fontWeight: "700",
                      border: "none",
                    }}
                    onClick={() => navigate("/")}
                  >
                    {General?.codeLabels["cm_usepassloginpagecancel"]?.label}
                  </button>
                  <button
                    type="submit"
                    disabled={
                      isSubmitting || 
                      !isValid || 
                      !dirty ||
                      !values.username
                    }
                    style={{
                      height: "3rem",
                      width: "132px",
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                      fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                      alignItems: "center",
                      backgroundColor: General?.contrast.contrastColor? General?.contrast.contrastColor === 'yellow' ? '#FFFF00' : (General.contrast.contrastColor === 'lime' ? '#00FF00' : '#101e8e'):General?.ColorAss?General?.ColorAss:'',
                      cursor: isSubmitting || !isValid || !dirty || !values.username ? 
                        "not-allowed" : "pointer",
                      color: General.contrast.contrastColor === 'yellow' ? '#0000FF' : (General.contrast.contrastColor === 'lime' ? '#000' : '#fff'),
                      fontWeight: "700",
                      border: "none",
                      opacity: isSubmitting || !isValid || !dirty || !values.username ? 
                        0.6 : 1,
                    }}
                  >
                    {renderButtonContent(isSubmitting)}
                  </button>
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
      </Box>
    </Container>
  );
};

export default observer(ForgotPassword);
